import React, { createContext, useContext, useState } from 'react';
import { translations, translateError } from './translations';
import { isNativeApp } from '../services/mcNative';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'pl');

  const t = (key) => {
    // W aplikacji Android wariant "klucz@app" (jeśli istnieje) wygrywa z bazowym —
    // teksty o wtyczce Chrome / komputerze / Ctrl+V dostają wersje apkowe bez
    // dotykania komponentów. W przeglądarce sufiks nigdy nie jest sprawdzany.
    if (isNativeApp()) {
      const appVal = translations[lang]?.[key + '@app'] ?? translations.pl[key + '@app'];
      if (appVal !== undefined) return appVal;
    }
    const val = translations[lang]?.[key] ?? translations.pl[key];
    return val !== undefined ? val : key;
  };

  const tErr = (msg) => translateError(msg, lang);

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem('lang', l);
  };

  return (
    <LangContext.Provider value={{ lang, t, tErr, changeLang }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
